"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isLinkRenderable = exports.getSiteLinksColumns = void 0;
var _staticApiClientReact = require("@ori/static-api-client-react");
var _constants = require("../components/SiteLinks/constants");
const isLinkRenderable = item => Boolean(item.title);
exports.isLinkRenderable = isLinkRenderable;
const getSiteLinksColumns = footer => {
  const footerColumns = footer?.children.filter(item => item.linkType === _staticApiClientReact.StaticNavigationNavigationItemDtoLinkType.FooterColumn);
  const columns = footerColumns?.filter(column => isLinkRenderable(column)).slice(0, _constants.MAX_COLUMNS) ?? [];
  const onlyRenderableChildren = columns.map(column => ({
    ...column,
    children: column.children.filter(child => isLinkRenderable(child))
  }));
  return onlyRenderableChildren;
};
exports.getSiteLinksColumns = getSiteLinksColumns;